//@ts-check
import Backbone from 'backbone';
import {isNil} from 'ramda';
import {cloneObject} from '../../sinclair/sinclair.utils';

export default Backbone.Model.extend({
    idAttribute: 'label',
    scaleWidthMap: {
        jumbo16x9: 1320,
        large16x9: 986,
        medium16x9: 648,
        small16x9: 160,

        jumbo36x25: 544,
        large36x25: 360,
        medium36x25: 144,
        small36x25: 72,

        jumbo1x1: 1440,
        large1x1: 360,
        medium1x1: 200,
        small1x1: 90,

        jumbo9x16: 1845,
        large9x16: 1440,
        medium9x16: 720,
        small9x16: 360,

        jumbo21x9: 1920,
        large21x9: 1280,
        medium21x9: 640,
        small21x9: 160,

        jumbo3x4: 1440,
        large3x4: 320,
        medium3x4: 480,
        small3x4: 120,

        jumbo3x1: 1920,
        large3x1: 1280,
        medium3x1: 640,
        small3x1: 160,

        jumbo2x3: 1280,
        large2x3: 854,
        medium2x3: 427,
        small2x3: 107,
    },
    defaults: {
        blurSigma: 0,
        height: 0,
        label: '',
        scaleWidth: 0,
        url: '',
        width: 0,
        x: 0,
        y: 0,
    },
    initialize(data) {
        if (data.rendition && data.rendition.startsWith('full')) {
            this.set({...data, scaleWidth: data.width});
        } else {
            this.set(data);
        }
        return this;
    },
    fixNulls() {
        const startPoints = ['x', 'y'];
        const dimensions = ['width', 'height', 'scaleWidth'];
        const cleanData = cloneObject(this.toJSON());
        startPoints.forEach(coord => (cleanData[coord] = isNil(cleanData[coord]) ? 0 : cleanData[coord]));

        const missingDimension = dimensions.some(dimension => isNil(cleanData[dimension]));

        if (missingDimension) {
            delete cleanData.width;
            delete cleanData.height;

            this.extrapolateWidthAndHeight();
        }
        return this.set(cleanData);
    },
    setParentDimensions(parent) {
        this.width = parent.width;
        this.height = parent.height;
        return this;
    },
    extrapolateWidthAndHeight() {
        const label = this.get('label');
        const arMap = {
            '16x9': 16 / 9,
            '36x25': 36 / 25,
            '3x4': 3 / 4,
            '9x16': 9 / 16,
            '1x1': 1,
            '21x9': 21 / 9,
            '3x1': 3,
            '2x3': 2 / 3,
        };
        const originalAspectRatio = this.width / this.height;
        const aspectRatio = Object.keys(arMap).reduce(
            (result, curr) => (label.includes(curr) ? arMap[curr] : result),
            originalAspectRatio,
        );
        let height, width;

        if (aspectRatio.toFixed(2) === originalAspectRatio.toFixed(2)) {
            // square
            height = this.height;
            width = this.width;
        } else if (this.width > this.height) {
            // landscape
            height = this.height;
            width = height * aspectRatio;
        } else {
            // portrait
            width = this.width;
            height = width * (1 / aspectRatio);
        }
        const scaleWidth = this.scaleWidthMap[label];
        this.set({width, height, scaleWidth});
    },
});
